/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
//  */

async function action({ store, url }, { siteId }) {
  const title = 'Home';
  const state = store.getState();
  const userData = (state.session || {}).USER_DATA;
  const modules = ((userData || {}).group || {}).modules || [];
  // const isSalon = !!(userData || {}).salon;
  // const isDistributor = !!(userData || {}).distributor;

  if (userData == null) {
    return {
      title,
      redirect: `/${siteId}/forbidden?redirect=${encodeURIComponent(
        url || '',
      )}`,
    };
  }

  if (modules.includes('mytracker')) {
    return {
      title,
      redirect: `/${siteId}/mytracker`,
    };
  }

  if (modules.includes('advisornet')) {
    return {
      title,
      redirect: `/${siteId}/engage360`,
    };
  }

  return {
    title,
    redirect: `/${siteId}/salondb`,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/client/site/default/index.js